import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserService } from 'app/services/users/user.service';
declare const swal: any;

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService
  ) { }

  recoverPasswordForm: FormGroup = this.formBuilder.group({
    email: ['', Validators.required]
  })

  ngOnInit(): void {
  }

  recoverPassword(){
    try {
      if(this.recoverPasswordForm.valid){
        this.userService.forgotPassword(this.recoverPasswordForm.value.email);
        this.openAlert(1);
      }else{
        this.openAlert(0)
      }
    } catch (error) {
      console.error(error);
    }
  }

  openAlert(type){
    switch (type) {
      case 1:
        swal({
          title: 'Correo enviado correctamente',
          text: '',
          type: 'success',
          timer: 3000,
          showConfirmButton: false
        })
        break;
      case 0:
        swal({
          title: 'Atención',
          text: 'Debes llenar todos los campos requeridos',
          type: 'warning',
          confirmButtonClass: 'btn btn-danger'
        })
    }
  }
}
